export default __webpack_public_path__ + "static/media/letthemburn.daca68f8.png";